/**
 * <cl-cart-upsell> adds a complementary product from the cart drawer in one click
 * (snippets/cl-cart-upsell.liquid). It goes through Shopify Standard Actions:
 * Horizon's cart-items-component listens for the resulting cart lines event and
 * re-renders the cart drawer section, which also removes the suggestion.
 * Loaded by snippets/cart-drawer.liquid so it is defined before the drawer re-renders.
 */
class ClCartUpsell extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('click', this.#onClick, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #onClick = async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-add-variant-id]') : null;
    if (!(button instanceof HTMLButtonElement) || button.getAttribute('aria-disabled') === 'true') return;
    if (!window.Shopify?.actions?.updateCart) return;

    button.setAttribute('aria-disabled', 'true');
    this.setAttribute('aria-busy', 'true');

    try {
      await window.Shopify.actions.updateCart(
        { lines: [{ merchandiseId: button.dataset.addVariantId, quantity: 1 }] },
        { event: { context: 'cart' } }
      );
    } catch (error) {
      console.warn('[cl-cart-upsell] add failed', error);
    } finally {
      if (button.isConnected) button.removeAttribute('aria-disabled');
      if (this.isConnected) this.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('cl-cart-upsell')) {
  customElements.define('cl-cart-upsell', ClCartUpsell);
}
